{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome-udvidelsen er ikke installeret.",
      "CTA": "Installer udvidelse"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Ingen forbindelse til telefonsystemet",
      "MESSAGE": "Din internetforbindelse ser ud til at være nede. Tjek den, og prøv igen.",
      "CREDENTIALS_TITLE": "Telefonsystemet afviste dine loginoplysninger",
      "CREDENTIALS_MESSAGE": "Telefonsystemet afviste brugernavnet eller adgangskoden, der er gemt i din profil. Tjek dem i Profilindstillinger, eller spørg din administrator.",
      "CONFIGURATION_TITLE": "Telefonindstillingerne er ikke gyldige",
      "CONFIGURATION_MESSAGE": "SIP-brugernavnet eller serveradressen har ikke et gyldigt format, så telefonen kan ikke oprette forbindelse. Ret det i Profilindstillinger.",
      "NETWORK_SHORT": "Forbindelse mislykkedes",
      "CREDENTIALS_SHORT": "Loginoplysninger afvist",
      "CONFIGURATION_SHORT": "Ugyldige telefonindstillinger",
      "RETRY": "Prøv igen",
      "DISMISS": "Annuller"
    },
    "CONNECTION_QUALITY": "Forbindelseskvalitet",
    "CONNECTION_QUALITY_EXCELLENT": "Fremragende",
    "CONNECTION_QUALITY_GOOD": "God",
    "CONNECTION_QUALITY_FAIR": "Middel",
    "CONNECTION_QUALITY_POOR": "Dårlig",
    "CONNECTION_QUALITY_DISCONNECTED": "Afbrudt",
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Historik"
    },
    "HISTORY": {
      "OPEN": "Åbn",
      "RECENT": "Seneste",
      "MISSED": "Ubesvarede",
      "LOADING": "Indlæser opkald...",
      "EMPTY": "Ingen opkald her",
      "ERROR": "Kunne ikke indlæse opkaldene",
      "CALL": "Ring tilbage",
      "CALL_STATUS": {
        "BUTTON": "Angiv opkaldsstatus",
        "TITLE": "Opkaldsstatus",
        "SEARCH_PLACEHOLDER": "Søg statusser...",
        "LOADING": "Indlæser statusser...",
        "NO_OPTIONS": "Ingen opkaldsstatusser er konfigureret",
        "NO_MATCH": "Ingen status matcher",
        "OPTIONS_ERROR": "Kunne ikke indlæse statusserne",
        "RETRY": "Prøv igen",
        "CONFIRM_QUESTION": "Vil du angive »{status}« og løse samtalen?",
        "CONFIRM": "Bekræft",
        "BACK": "Tilbage",
        "CANCEL": "Annuller",
        "SAVING": "Gemmer...",
        "SAVE_ERROR": "Kunne ikke gemme status",
        "RESOLVE_ERROR": "Status gemt, men samtalen kunne ikke løses"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefonnummer, f.eks. +421903000000",
      "BODY_PLACEHOLDER": "Skriv din besked ...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Send SMS",
      "SENDING": "Sender ...",
      "SENT": "SMS sendt",
      "LOADING": "Indlæser SMS-indbakker ...",
      "NO_INBOX": "Denne konto har ingen SMS-indbakke, så der kan ikke sendes SMS.",
      "INVALID_NUMBER": "Indtast nummeret i internationalt format, inklusive det indledende +.",
      "ERROR": "SMS'en kunne ikke sendes. Prøv igen."
    },
    "ACTIONS": {
      "CONNECT": "Forbind",
      "GO_TO_TAB": "Gå til den fane",
      "DISCONNECT": "Afbryd",
      "ANSWER": "Besvar",
      "HANGUP": "Læg på",
      "HOLD": "Sæt på hold",
      "MUTE": "Slå mikrofon fra",
      "SILENCE": "Slå lyd fra",
      "TRANSFER": "Overfør",
      "COMPLETE_TRANSFER": "Fuldfør overførsel",
      "RETURN_TO_CALLER": "Tilbage til opkalder",
      "CANCEL_TRANSFER": "Annuller overførsel",
      "DIALPAD": "Vis taltastatur",
      "OPEN_CONVERSATION": "Åbn samtale"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Indgående opkald",
      "INCOMING_CALL_FROM": "Indgående opkald fra {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Indgående opkald fra {number}",
      "ANSWER": "Besvar",
      "DECLINE": "Afvis"
    },
    "TRANSFER": {
      "TITLE": "Overfør opkald",
      "PLACEHOLDER": "Indtast nummer til overførsel...",
      "SEARCH_PLACEHOLDER": "Søg agenter...",
      "TARGET_PLACEHOLDER": "Valgt overførselsmål",
      "CONFIRM": "Overfør",
      "MODE_DIRECT": "Overfør nu",
      "MODE_CONSULT": "Ring til agent først",
      "CANCEL": "Annuller"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Er du sikker på, at du vil holde pause for alle køer?",
      "CONFIRM_READY": "Er du sikker på, at du vil gå tilbage til klar-status for alle køer?",
      "CONFIRM_BREAK_QUEUE": "Er du sikker på, at du vil logge ud af køen {queue}?",
      "CONFIRM_READY_QUEUE": "Er du sikker på, at du vil logge ind på køen {queue}?",
      "LOGIN_TO_QUEUE": "Log ind",
      "LOGOUT_FROM_QUEUE": "Log ud",
      "LOGIN_TO_ALL_QUEUES": "Log ind på alle køer",
      "LOGOUT_FROM_ALL_QUEUES": "Log ud af alle køer",
      "OPTION_LOGOUT": "Log ud",
      "OPTION_BREAK": "Pause",
      "OPTION_LUNCH": "Frokost",
      "OPTION_AWAY": "Fraværende",
      "OPTION_DO_NOT_DISTURB": "Må ikke forstyrres",
      "OPTION_BUSINESS_TRIP": "Forretningsrejse",
      "CONFIRM": "Bekræft",
      "CANCEL": "Annuller"
    },
    "STATUS": {
      "OFFLINE": "Telefon offline",
      "IN_OTHER_TAB": "Telefon forbundet i en anden fane",
      "CONNECTING": "Opretter forbindelse...",
      "DISCONNECTING": "Afbryder forbindelse...",
      "ONLINE": "Telefon online",
      "DIALING": "Ringer op",
      "TRANSFERRING": "Overfører...",
      "CONSULTING": "Taler med agent",
      "CALLER_ON_HOLD": "Opkalderen er sat på hold",
      "BUSY": "Optaget",
      "DND": "DND",
      "UNAVAILABLE": "Utilgængelig",
      "REJECTED": "Opkald afvist",
      "CALL_FAILED": "Opkald mislykkedes"
    },
    "QUEUES": {
      "MORE": "Flere køer"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Ringer op til {number}… Du kan lukke denne fane.",
    "NO_NUMBER": "Intet nummer angivet. Brug ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Indtast telefonnummer...",
    "ACTIONS": {
      "DIAL": "Ring op",
      "DIAL_FROM": "Vælg nummeret, du ringer fra"
    },
    "DIAL_FROM": {
      "TITLE": "Ring fra en indbakkes nummer"
    },
    "VALIDATION": {
      "REQUIRED": "Telefonnummer er påkrævet",
      "INVALID_FORMAT": "Ugyldigt format på telefonnummer"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Lydindstillinger og test",
    "SELECT_DEVICE": "Vælg enhed...",
    "SYSTEM_DEFAULT": "Systemstandard",
    "SAVED": "Gemt",
    "DISCONNECTED_SUFFIX": "ikke tilsluttet",
    "DEVICE_DISCONNECTED": "Den valgte enhed er ikke tilsluttet. Opkald bruger systemstandarden, indtil den er tilbage.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Test mikrofon",
      "STOP_TEST": "Stop test",
      "LEVEL": "Niveau:",
      "VERDICT": {
        "LISTENING": "Sig noget i mikrofonen…",
        "SILENT": "Du kan ikke høres. Kontrollér, at mikrofonen er tændt, og at den rigtige er valgt.",
        "LOW": "Du kan kun høres svagt. Vælg en anden mikrofon, eller juster inputlydstyrken i systemindstillingerne.",
        "GOOD": "God lyd — du kan høres tydeligt."
      }
    },
    "SPEAKER": {
      "TITLE": "Højttaler",
      "TEST": "Test højttaler",
      "TESTING": "Tester...",
      "VOLUME": "Lydstyrke:",
      "USING_DEFAULT": "Den valgte udgang er ikke tilgængelig — afspillet via systemstandarden."
    },
    "DONE": "Udført",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Der opstod en fejl ved adgang til mikrofonen. Kontrollér tilladelserne.",
      "MICROPHONE_PERMISSION_DENIED": "Adgang til mikrofonen er blokeret. Tillad det i browserens webstedsindstillinger for at bruge telefonen.",
      "MICROPHONE_SILENT": "Din mikrofon opfanger ingen lyd. Kontrollér dine lydindstillinger.",
      "EXTENSION_REQUIRED": "Telefonudvidelsen blev ikke registreret. Installer eller aktiver den for at bruge mikrofonen.",
      "SPEAKER_TEST": "Der opstod en fejl ved test af højttalerudgang."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Optaget"
  },
  "QUEUE_STATUS": {
    "READY": "Klar",
    "NOT_READY": "Modtager ikke opkald",
    "WRAP_UP": "Efterbehandling",
    "BREAK": "Pause",
    "LUNCH": "Frokost",
    "AWAY": "Fraværende",
    "DO_NOT_DISTURB": "Må ikke forstyrres",
    "BUSINESS_TRIP": "Forretningsrejse",
    "OTHER_CALL": "Andet opkald",
    "QUEUE_CALL": "Kø-opkald",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Ingen telefon",
    "PARTIALLY_READY": "Delvist klar",
    "MIXED": "Blandet",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Optaget (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
